import ProductGrid from "@/components/ProductGrid";

export default function Shop() {
  return (
    <ProductGrid
      eyebrow="The Sanctuary Shop"
      title="Everything we make, in one quiet place."
      blurb="Browse all hand-poured candles, floral planters, and growth oils. Each piece is small-batch, made in studio with care."
    />
  );
}
